"use strict";

var obj = {
  white: '#ffffff',
  fog: '#f9f9f9',
  antiFlashWhite: '#f2f3f4',
  ash: '#dfdfdf',
  whisper: '#e6e6e6',
  silver: '#c8c8c8',
  greyChateau: '#97999c',
  steel: '#898989',
  grey: '#767676',
  charcoal: '#555d5d',
  matterhorn: '#555555',
  almostBlack: '#333737',
  primary: '#3c9700',
  primaryLight: '#66b100',
  primaryDark: '#286400',
  primaryGradient: 'linear-gradient(to right, #3c9700, #66b100)',
  secondary: '#ff6200',
  secondaryLight: '#ff8800',
  secondaryDark: '#cc4e00',
  secondaryGradient: 'linear-gradient(to right, #ff6200, #ff8800)',
  info: '#459fd0',
  success: '#3c9700',
  error: '#ed1c24',
  highlight: '#efa729',
  disabled: '#7a7a7a',
  disabledBackground: 'linear-gradient(to right, #e6e6e6, #f2f3f4)',
  required: '#f8033f',
  crown: '#d4af37',
  subscription: '#6915b5',
  shadow: '#000000'
};
module.exports = obj;